// extracted by mini-css-extract-plugin
module.exports = {"profile":"profileIndex_profile__KESj8"};